var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33331 5.14706L16.6666 5.14706M13.3333 17.5H6.66665C5.74617 17.5 4.99998 16.7099 4.99998 15.7353V6.02941C4.99998 5.5421 5.37308 5.14706 5.83331 5.14706H14.1666C14.6269 5.14706 15 5.5421 15 6.02941V15.7353C15 16.7099 14.2538 17.5 13.3333 17.5ZM8.33331 5.14706H11.6666C12.1269 5.14706 12.5 4.75202 12.5 4.26471V3.38235C12.5 2.89504 12.1269 2.5 11.6666 2.5H8.33331C7.87308 2.5 7.49998 2.89504 7.49998 3.38235V4.26471C7.49998 4.75202 7.87308 5.14706 8.33331 5.14706Z",
    stroke: "#EA4335",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.3a8f17756c06cbbd398d70a9afd2caa9.svg";
export { ForwardRef as ReactComponent };